import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useCustomSnackbarAction } from '../common/components/common-snackbar';
import useNetwork from '../common/hooks/useNetwork';

export const useOfflineSnackbar = () => {
  const isOnline = useNetwork();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const customSnackbarAction = useCustomSnackbarAction();

  useEffect(() => {
    if (!isOnline) {
      enqueueSnackbar(t('common:commonValues.offlineMessage'), {
        persist: true,
        action: customSnackbarAction,
      });
    } else {
      closeSnackbar();
    }
  }, [isOnline]);
};
